<div class="login-container">

  <app-loading-spinner [isLoading]="daveningService.loading()"></app-loading-spinner>

  <div class="login-box">

    <h3 class="title">Admin Login</h3>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

      <div class="form-group">
        <label for="email">Email</label>
        <input type="text" id="email" formControlName="email" class="form-control">
        <span *ngIf="!loginForm.get('email')?.valid && loginForm.get('email')?.touched"
              class="help-block">Please enter a valid email</span>
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <input type="password" id="password" formControlName="password" class="form-control">
        <span *ngIf="!loginForm.get('password')?.valid && loginForm.get('password')?.touched"
              class="help-block">Password is required</span>
      </div>

      <button type="submit" class="btn-ok login-btn btn btn-success" [disabled]="!loginForm.valid">
        Login
      </button>

    </form>
  </div>

</div>